<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button
            variant="primary mr-1"
            @click="showFormUpload = !showFormUpload"
            ><i class="fa fa-cloud-upload"></i> Import (.xlsx)</b-button
          >
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Bank</label>
            </b-input-group-prepend>
             <b-form-select
              v-model="tblData.kodebank"
              :plain="true"
              :options="optBank"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col
          
        >
          <b-input-group>
            <b-input-group-prepend>
               <b-form-select
              v-model="tblData.typeDate"
              :plain="true"
              :options="optDate"
            ></b-form-select>
            </b-input-group-prepend>
            <b-form-input type="date" v-model="tblData.tanggal"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <!-- <template v-slot:cell(custinfo)="data">{{data.item.CustCode}} | {{data.item.CustName}}</template> -->
        <template v-slot:cell(transaction_date)="data">{{
          data.item.transaction_date | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(createdat)="data">{{
          data.item.createdat | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(debit)="data">{{
          data.item.debit | numFormat("0,0.00")
        }}</template>
         <template v-slot:cell(credit)="data">{{
          data.item.credit | numFormat("0,0.00")
        }}</template>

        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showFormUpload"
      title="Upload Form"
      :centered="true"
      @ok="reprocessbyfilename"
    >
      <b-input-group>
        <b-input-group-prepend>
          <label>Bank</label>
        </b-input-group-prepend>
        <b-form-select
          v-model="tblData.kodebank"
          :plain="true"
          :options="optBank"
        ></b-form-select>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label>File</label>
        </b-input-group-prepend>
         <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".xlsx, .xls, .csv"
          ></b-form-file>
      </b-input-group>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import transactionbank from "../../apis/transactionbank";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      showReprocessByFilenameConfirm: false,
      showFormUpload:false,
      isLoading: false,
      isBusy: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tanggal: moment().format("YYYY-MM-DD"),
        typeDate:'createdAt',
        kodebank:'ALDANA-11118',
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
      optBank:[],
      optDate:[
        {value:'createdAt',text:'Upload Date'},
        {value:'transaction_date',text:'Transaction Date'}
      ],
      file:null
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "transaction_date",
          label: "Transaction Date",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "transaction_code",
          label: "Code",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "transaction_type",
          label: "Type",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "debit",
          label: "Debit",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "credit",
          label: "Credit",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "cheque_number",
          label: "Cheque Number",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "reference_number",
          label: "Reference Number",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "customer_reference_number",
          label: "Cust. Ref. Number",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createdat",
          label: "Upload At",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
      ];
      return fields;
    },
    // progessupload() {
    //   let progessupload = this.$store.state.progessupload;
    //   if (progessupload && progessupload.refreshdata) {
    //     this.refresh();
    //     this.$refs["modalprogress"].hide();
    //     this.$store.commit("progessupload", {});
    //   }
    //   return progessupload;
    // },
  },
  async created() {
    try {
      this.isLoading = true;
      const [bank] = await Promise.all([
        crud.list({
            tablename: "bank",
                page: 1,
              limit: 100,
              total: 0,
            customQuery: `aktif=1&isbank=1`,
          })
      ]);
      this.optBank = bank.map(dt=>{
        return {value:dt.kode,text:dt.namabank}
      });
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isLoading = true;
        // const filter = this.$store.state.filter;
        let filtered = false;
        // for (var key in filter.debiturList) {
        //   this.tblData[key] = filter.debiturList[key];
        //   filtered = true;
        // }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
       
        
        const list = await transactionbank.list(this.tblData);
        this.isLoading = false;
        return list;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async reprocessbyfilename(){
      try {
          this.isLoading = true;
          await transactionbank.upload(this.file,this.tblData);
          this.isLoading=false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          // toastr.error(error.message, "ERROR MESSAGE", 10000);
          this.$bvModal.msgBoxOk(error.message, {
            title: 'ERROR MESSAGE',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })

        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: "disbursementupload",
        customQuery: "",
        tgl1: "",
        tgl2: "",
        partnerTransactionId: "",
        loan_id: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>